import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../../../_constants/validation-format-constants';
import { UserNameDisplayResultDto } from '../../../../../_models/user-name-display-result-dto';
import { APAdjustmentAttachmentRawDto } from './ap-adjustment-attachement-raw-dto';
import { APAdjustmentItemRawDto } from './ap-adjustment-item-raw-dto';

export class APAdjustmentRawDto {
    apAdjustmentId: number;
    managementCompanyId: number;
    communityId: number;
    debitOrCredit: string;
    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    docDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    postDate: Date;

    vendorId: number;
    amount: number;
    openBalance: number;
    description: string;
    @Type(() => APAdjustmentItemRawDto)
    items: APAdjustmentItemRawDto[];
    @Type(() => APAdjustmentAttachmentRawDto)
    attachments: APAdjustmentAttachmentRawDto[];
    @Type(() => UserNameDisplayResultDto)
    updatedByUser: UserNameDisplayResultDto;
}
